<mc-side-bar>
  <nav class="mds-tree-nav" role="navigation" aria-label="side navigation">
    <ul>
      @if (!authPolicy.isEquipmentOperatorOnly) {
        <!-- Work Orders -->
        <li>
          <details [open]="isWorkorderSubMenuOpen" (toggle)="toggleWorkorderSubMenu($event)">
            <summary i18n><mc-icon icon="wrench"></mc-icon><span data-cy="workorders">Workorders</span></summary>
            <ul>
              <li>
                <a routerLink="/workorders" routerLinkActive="mds-tree-nav__active" [routerLinkActiveOptions]="{ exact: true }" i18n
                  >View All</a
                >
              </li>
              @if (authPolicy.canCreateWorkOrder) {
                <li>
                  <a routerLink="/workorders/create/single-equipment" routerLinkActive="mds-tree-nav__active" i18n>Create Single</a>
                </li>

                <li>
                  <a routerLink="/workorders/create/multiple-equipments" routerLinkActive="mds-tree-nav__active" i18n>Create Multiple</a>
                </li>
              }
              @if (enableVesselWoFileProcessing() && authPolicy.canViewVesselWoProcessing) {
                <li>
                  <a routerLink="/workorders/create/multiple-equipments-vessel-shop" routerLinkActive="mds-tree-nav__active" i18n
                    >Vessel Shop</a
                  >
                </li>
              }
            </ul>
          </details>
        </li>

        <!-- Reports Group -->
        <li>
          <details [open]="isReportsSubMenuOpen" (toggle)="toggleReports($event)">
            <summary i18n><mc-icon icon="briefcase"></mc-icon><span data-cy="reports">Reports</span></summary>
            <ul>
              @if (authPolicy.isUserGSCorAdminorAppSupportAdminAccess && enableOperationalReports()) {
                <li>
                  <a routerLink="/reports/operational-report" routerLinkActive="mds-tree-nav__active" i18n> Operational Report </a>
                </li>
              }
              <li>
                <a routerLink="/reports/workorders-export" routerLinkActive="mds-tree-nav__active" i18n> Export Workorders </a>
              </li>
              @if (enableReplacedParts() && !authPolicy.isProcurementOnly) {
                <li>
                  <a routerLink="/reports/replaced-parts-export" routerLinkActive="mds-tree-nav__active" i18n> Replaced Parts </a>
                </li>
              }
            </ul>
          </details>
        </li>

        <!-- Booking Assignment -->
        @if (enableBookingAssignment() && authPolicy.canViewBookingAssignment) {
          <li>
            <a routerLink="/booking-assignment" routerLinkActive="mds-tree-nav__active" i18n>
              <mc-icon icon="crosshair"></mc-icon>
              Booking Assignment
            </a>
          </li>
        }

        <!-- Container DMRL -->
        @if (enableDmrl() && authPolicy.canViewDmrl) {
          <li>
            <a routerLink="/container-dmrl" routerLinkActive="mds-tree-nav__active" i18n>
              <mc-icon icon="container"></mc-icon>
              Container DMRL
            </a>
          </li>
        }

        <!-- Approvals Group -->
        @if (enableManualWorkOrderApproval() && authPolicy.canViewManualWorkOrder) {
          <li>
            <details [open]="isApprovalWOSubMenuOpen" (toggle)="toggleApprovalWOSubMenu($event)">
              <summary i18n><mc-icon icon="stamp"></mc-icon><span data-cy="approvals"></span>Approvals</summary>
              <ul>
                <li>
                  <a routerLink="/approvals/all" routerLinkActive="mds-tree-nav__active" i18n> All </a>
                </li>
                @if (enableMyWorkOrder() && authPolicy.canViewMyWorkOrder) {
                  <li>
                    <a routerLink="/approvals/my-workorders" routerLinkActive="mds-tree-nav__active" i18n> My WorkOrders </a>
                  </li>
                }
              </ul>
            </details>
          </li>
        }

        <!-- Approval Settings Group -->
        @if (authPolicy.canViewApprovalSettings) {
          <li>
            <details [open]="isApprovalSubMenuOpen" (toggle)="toggleSubMenu($event)">
              <summary i18n><mc-icon icon="cog"></mc-icon><span data-cy="approval-settings"></span>Approval Settings</summary>
              <ul>
                <li>
                  <a routerLink="/approvalSettings/disableValidation" routerLinkActive="mds-tree-nav__active" i18n> Disable Validations </a>
                </li>
                <li>
                  <a routerLink="/approvalSettings/masterDataConfig" routerLinkActive="mds-tree-nav__active" i18n> Master Data Config </a>
                </li>
              </ul>
            </details>
          </li>
        }

        <!-- Scorecard -->
        @if (
          (authPolicy.canViewVSCReports && enableVSC() && enableVSCShop()) ||
          (authPolicy.canViewVSCReportsProd && enableVSC() && !enableVSCShop())
        ) {
          <li>
            <details [open]="isScorecardSubMenuOpen" (toggle)="toggleScorecardSubMenu($event)">
              <summary i18n><mc-icon icon="medal"></mc-icon><span></span>Scorecard</summary>
              <ul>
                <li>
                  <a routerLink="/scorecard" routerLinkActive="mds-tree-nav__active" [routerLinkActiveOptions]="{ exact: true }" i18n
                    >Scorecard</a
                  >
                </li>
                @if (authPolicy.isUserGSCorAdminorAppSupportAdminAccess) {
                  <li>
                    <a routerLink="/scorecard/settings" routerLinkActive="mds-tree-nav__active" i18n>Settings</a>
                  </li>
                }
              </ul>
            </details>
          </li>
        }

        <!-- Repair Alerts -->
        @if (authPolicy.isUserGSCorAdminorAppSupportAdminAccess) {
          <li>
            <a routerLink="/repair-alerts" routerLinkActive="mds-tree-nav__active" i18n>
              <mc-icon icon="cog"></mc-icon>
              Repair Alerts
            </a>
          </li>
        }

        <!-- Master Data -->
        @if (enableMasterData() && authPolicy.canViewMasterData) {
          <li>
            <a routerLink="/master-data" routerLinkActive="mds-tree-nav__active" i18n>
              <mc-icon icon="database"></mc-icon>
              Master Data
            </a>
          </li>
        }

        <!-- AI Assistant -->
        @if (enableAIagent()) {
          <li>
            <a routerLink="/assistant" routerLinkActive="mds-tree-nav__active" i18n>
              <mc-icon icon="chatbot"></mc-icon>
              AI Assistant
            </a>
          </li>
        }
      }
      <!-- end @if(!authPolicy.isEquipmentOperatorOnly) -->

      <!-- In Advance Container visibility -->
      @if (showAdvanceContainerVisibility()) {
        <li>
          <a routerLink="/container-visibility" routerLinkActive="mds-tree-nav__active" i18n>
            <mc-icon icon="eye"></mc-icon>
            Advance Container Visibility
          </a>
        </li>
      }

      @if (enableImportDemandConfiguration() && authPolicy.canViewImportSteeringDemands) {
        <li>
          <a routerLink="/import-demand-configuration" routerLinkActive="mds-tree-nav__active" i18n>
            <mc-icon icon="tray-arrow-down"></mc-icon>
            Import Steering Demands
          </a>
        </li>
      }

      <!-- Container Stock View (all AEMS personas except shops) -->
      @if (enableContainerStockView() && authPolicy.canViewContainerStock) {
        <li>
          <a routerLink="/container-stock" routerLinkActive="mds-tree-nav__active" i18n>
            <mc-icon icon="container"></mc-icon>
            Container Stock View
          </a>
        </li>
      }

      <!-- App Support Group -->
      @if (authPolicy.isAppSupportAdmin) {
        <li>
          <details [open]="isAppSupportSubMenuOpen" (toggle)="toggleAppSupport($event)">
            <summary i18n><mc-icon icon="headset"></mc-icon><span data-cy="app-support"></span>App Support</summary>
            <ul>
              <li>
                <a routerLink="/app-support/retrigger" routerLinkActive="mds-tree-nav__active" i18n> Workorder Actions </a>
              </li>
              <li>
                <a routerLink="/app-support/shop" routerLinkActive="mds-tree-nav__active" i18n> Shop </a>
              </li>
            </ul>
          </details>
        </li>
      } @else if (authPolicy.canAccessRetriggerPage) {
        <li>
          <a routerLink="/app-support/retrigger" routerLinkActive="mds-tree-nav__active" i18n>
            <mc-icon icon="headset"></mc-icon>
            Workorder Actions
          </a>
        </li>
      }

      <!-- Users -->
      @if (authPolicy.canViewUsers) {
        <li>
          <a routerLink="/users" routerLinkActive="mds-tree-nav__active" i18n>
            <mc-icon icon="people"></mc-icon>
            Users
          </a>
        </li>
      }

      <!-- Rise -->
      @if (enableRise() && authPolicy.isEmailIdAllowed) {
        <li>
          <details [open]="isRiseSubMenuOpen" (toggle)="toggleRiseSubMenu($event)">
            <summary i18n><mc-icon icon="anchor"></mc-icon><span data-cy="rise">Rise</span></summary>
            <ul>
              @if (enableRiseImageAnalytics()) {
                <li>
                  <a routerLink="/rise/image-analytics/work-orders" routerLinkActive="mds-tree-nav__active" i18n>Work Orders</a>
                </li>
                <li>
                  <a routerLink="/rise/image-analytics/images" routerLinkActive="mds-tree-nav__active" i18n>Image Grid</a>
                </li>
              }
            </ul>
          </details>
        </li>
      }

      <!-- Footer section separator -->
      <li class="mds-tree-nav--separator"></li>
    </ul>
  </nav>
  <footer>
    <div>Version: {{ appVersion }}</div>
    <div>&#9400;A.P Moller-Maersk</div>
  </footer>
</mc-side-bar>
